/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all ExchangeRate.
const deps = ['ExchangeRate', 'Collection'];
const factory = function (ExchangeRate, Collection) {
  let ExchangeRateCollection;
  return (ExchangeRateCollection = (function () {
    ExchangeRateCollection = class ExchangeRateCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        this.prototype.$resource = 'exchangerate';
        this.prototype.$type = ExchangeRate;
      }

      $url() {
        return `${super.$url()}/${this.$id}`;
      }

      $init() {
        super.$init();

        // Automatically fetch the first time this collection is created.
        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }
    };
    ExchangeRateCollection.initClass();
    return ExchangeRateCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/exchangeRate').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.exchangeRate', moduleDeps)
  .factory('ExchangeRateCollection', factory);
